import { MenuItem, Select } from "@mui/material";

const SelectComponent = ({ children, value, label, onChange, width }) => {
  return (
    <Select
      label={label ?? ""}
      sx={{
        "& .MuiOutlinedInput-input": {
          padding: "10px",
          width: width ?? "100%",
          fontSize: "14px",
        },
        "& .MuiSvgIcon-root": {
          color: "var(--main-color)",
        },
      }}
      value={value}
      onChange={(event) => onChange(event)}
      MenuProps={{
        PaperProps: {
          sx: {
            width: "auto",
            backgroundColor: "var(--bkg-secondary)",
            "& .MuiMenuItem-root": {
              fontSize: "14px",
            },

            "& .MuiMenuItem-root.Mui-selected": {
              backgroundColor: "transparent",
            },

            "& .MuiMenuItem-root:hover": {
              backgroundColor: "var(--bkg-tertiary)",
            },
          },
        },
      }}
    >
      {children}
    </Select>
  );
};

export default SelectComponent;
